export default __webpack_public_path__ + "static/media/sao-paulo.2757c712.png";